import React from "react";
import { FaStar } from "react-icons/fa6";
import { Container, H2_SIZE } from "./ui";

const ratings = [
  { img: "https://d3vqz9qyn2r1xe.cloudfront.net/imges/clutch_img1.svg", alt: "Clutch", score: "4.8" },
  { img: "https://d3vqz9qyn2r1xe.cloudfront.net/imges/Lp-img2.svg", alt: "DesignRush", score: "4.9" },
  { img: "https://d3vqz9qyn2r1xe.cloudfront.net/imges/Lp-img3.svg", alt: "TopDevelopers", score: "4.6" },
  { img: "https://d3vqz9qyn2r1xe.cloudfront.net/imges/Lp-img4.svg", alt: "GoodFirms", score: "4.4" },
  { img: "https://d3vqz9qyn2r1xe.cloudfront.net/imges/Mo-logo4.png", alt: "Google", score: "4.8" },
];

const Ratings = () => (
  <section className="bg-white py-[64px] lg:py-[80px]">
    <Container>
      <h2 className={`mx-auto max-w-3xl text-center font-extrabold tracking-tight text-ink ${H2_SIZE}`}>
        India&apos;s One Of The Highest Rated Web Development Company
      </h2>
      <p className="mt-[12px] text-center text-[16px] font-medium text-[#1E3A8A]">
        100+ Glowing 5-Star Reviews Across Top B2B Review Platforms
      </p>
      <div className="mx-auto mt-[40px] grid max-w-5xl grid-cols-2 gap-[16px] sm:grid-cols-3 lg:grid-cols-5">
        {ratings.map((r) => (
          <div
            key={r.alt}
            className="flex flex-col items-center rounded-2xl bg-white px-[16px] py-[24px] ring-1 ring-slate-200 transition hover:-translate-y-1 hover:shadow-card"
          >
            <div className="flex h-[88px] items-center justify-center">
              <img src={r.img} alt={r.alt} className="max-h-[88px] w-auto object-contain" />
            </div>
            <div className="mt-[16px] flex gap-1 text-[15px] text-amber-400">
              {[0, 1, 2, 3, 4].map((i) => (
                <FaStar key={i} />
              ))}
            </div>
            <p className="mt-2 text-[28px] font-bold text-slate-700">{r.score}</p>
          </div>
        ))}
      </div>
    </Container>
  </section>
);

export default Ratings;
